module.exports = __webpack_public_path__ + "img/10.68e0edf9.png";